import React, { Component } from "react";
import { RecentRegistrations } from "components/admin/Admin/RecentRegistrations";
import AuthService from "services/auth.service";
import AdminsService from "services/admins.service";
import Search from "assets/images/icons/Search.svg";
import Download from "assets/images/icons/Download.svg";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";

let currentUser = AuthService.getCurrentUser();

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stores: [],
      registrations: [],
      search: "",
      search_text: "",
      total_registrations: 0,
      downloadRange: 0,
      loading: false,
    };
  }

  reloadList(param) {
    AdminsService.dashboard(param).then(
      (data) => {
        this.setState({
          stores: data.stores,
          registrations: data.registrations,
          total_registrations: data.total,
        });
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/admin/login");
        }
      }
    );
  }

  downloadCsv() {
    if (this.state.loading) {
      return;
    }
    this.setState({ loading: true });

    const params = {
      offset: parseInt(this.state.downloadRange),
    };

    AdminsService.downloadCsv(params).then(
      (data) => {
        this.setState({ loading: false });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        const minRange = params.offset * 1000 + 1;
        const maxRange = (params.offset + 1) * 1000;
        const filename = `${moment(new Date()).format("YYYY-MM-DD")} - ${
          currentUser?.store_name
        } - Registrations Export (${minRange} - ${maxRange}).csv`;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  }

  componentDidMount() {
    this.reloadList();
  }

  handleEnterKey(e) {
    if (e.key === "Enter") {
      let param = {
        phone_number: this.state.search,
      };
      this.setState({
        search_text: this.state.search,
      });
      this.reloadList(param);
    }
  }

  render() {
    const ranges = [];
    const gapSize = 1000;
    const maxSize = Math.floor(this.state.total_registrations / gapSize) + 1;

    for (let i = 0; i < maxSize; i++) {
      ranges.push(i);
    }

    const selectOptions = ranges.map((value) => {
      const minRange = value * gapSize + 1;
      let maxRange = (value + 1) * gapSize;
      maxRange =
        this.state.total_registrations < maxRange
          ? this.state.total_registrations
          : maxRange;

      return (
        <option key={value} value={value}>
          {minRange} - {maxRange}
        </option>
      );
    });

    return (
      <div className="admin-page">
        <h4 style={{ fontWeight: "bold" }}>Admin Portal</h4>
        <p>Welcome Back, Admin.</p>

        <div className="d-flex align-items-center justify-content-between">
          <span className="search-box d-block d-sm-inline-block">
            <img src={Search} alt="search-icon" id="search-icon" />

            <input
              type="text"
              placeholder="Search by Phone No. (e.g. 60123456789)"
              className="form-control rounded-pill"
              value={this.state.search}
              onChange={(e) => this.setState({ search: e.target.value })}
              onKeyDown={(e) => this.handleEnterKey(e)}
            />
          </span>

          <div className="d-flex align-items-center">
            <div
              className="conditional-display"
              displayed={this.state.loading.toString()}
            >
              <Spinner animation="border" className="spinner" />
            </div>

            <span className="mx-4 mb-0">
              <b>Download</b>
            </span>

            <select
              className="form-control rounded-pill px-4"
              value={this.state.downloadRange}
              onChange={(e) => this.setState({ downloadRange: e.target.value })}
            >
              {selectOptions}
            </select>

            <img
              src={Download}
              alt="list-options-btn"
              className="ms-4 clickable w-em-7"
              title="Download Excel"
              onClick={() => this.downloadCsv()}
            />
          </div>
        </div>

        <h5 className="mt-4 mb-2">Recent Registrations</h5>

        <div style={{ fontSize: "0.8em" }}>
          {this.state.registrations.length > 0 ? (
            <RecentRegistrations
              items={this.state.registrations}
              handleReload={() => this.reloadList()}
            />
          ) : (
            <div className="pt-2">
              {this.state.search_text.length > 0 ? (
                <p>
                  Phone Number '<i>{this.state.search_text}</i> ' cannot be
                  found
                </p>
              ) : (
                <p>No new registrations</p>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export { Admin };
